var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCratrLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 694.93,
    height: 216.92,
    viewBox: "0 0 694.93 216.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Unbenannter_Verlauf_61);\n      }\n\n      .cls-2 {\n        fill: url(#Unbenannter_Verlauf_57);\n      }\n\n      .cls-3 {\n        fill: url(#Unbenannter_Verlauf_55);\n      }\n\n      .cls-4 {\n        fill: url(#Unbenannter_Verlauf_53);\n      }\n\n      .cls-5 {\n        fill: url(#Unbenannter_Verlauf_51);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_61",
    "data-name": "Unbenannter Verlauf 61",
    x1: 524.98,
    y1: 108.61,
    x2: 694.93,
    y2: 108.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02193a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#012762"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_57",
    "data-name": "Unbenannter Verlauf 57",
    x1: 397.05,
    y1: 108.61,
    x2: 578.44,
    y2: 108.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#17394c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#205374"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_55",
    "data-name": "Unbenannter Verlauf 55",
    x1: 267.71,
    y1: 108.61,
    x2: 470.29,
    y2: 108.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386b67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c9793"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_53",
    "data-name": "Unbenannter Verlauf 53",
    x1: 145.49,
    y1: 108.61,
    x2: 315.44,
    y2: 108.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5aa085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6dc9a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_51",
    "data-name": "Unbenannter Verlauf 51",
    y1: 108.46,
    x2: 199,
    y2: 108.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#78ce9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92fec0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M525,211.67V5.56h85.29q33.06,0,53.14,17.15T683.5,73.23q0,20.1-9,35.23a68.43,68.43,0,0,1-23.8,24.1l44.19,79.11H654.19a29,29,0,0,1-26-16.09l-22.49-45.19a16,16,0,0,0-14.33-8.87H591a12.59,12.59,0,0,0-12.59,12.59v46.82a10.74,10.74,0,0,1-10.74,10.74ZM578.44,84.83a13.74,13.74,0,0,0,13.74,13.74H605q10.82,0,17.61-6.64t6.8-17.77c0-7.83-2-11.62-6.36-16.15s-11.3-4.55-19.13-4.55H578.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M460.4,211.67v-149a9.2,9.2,0,0,0-9.21-9.2H397.05V5.56H567.58a10.86,10.86,0,0,1,10.86,10.86v37H525a9.32,9.32,0,0,0-9.32,9.32V211.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M269,184.33,330.9,15.76a15.55,15.55,0,0,1,14.6-10.2h51.87l72.92,206.11h-59l-9.83-31.56A15.77,15.77,0,0,0,386.38,169H340.61a15.78,15.78,0,0,0-15,11l-10.1,31.66H288.06A20.32,20.32,0,0,1,269,184.33Zm80.21-55.17H378a6.59,6.59,0,0,0,6.31-8.5L364,53.46l-21.1,67.13A6.59,6.59,0,0,0,349.19,129.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M145.49,211.67V5.56h85.29q33.06,0,53.14,17.15T304,73.23q0,20.1-9,35.23a68.48,68.48,0,0,1-23.79,24.1l44.18,79.11h-40.9a28.75,28.75,0,0,1-25.74-15.95l-22.67-45.53a15.63,15.63,0,0,0-14-8.67h-.77A12.41,12.41,0,0,0,199,153.93v49.52a8.22,8.22,0,0,1-8.22,8.22ZM199,86.12A12.44,12.44,0,0,0,211.4,98.57h14.12q10.81,0,17.62-6.64t6.8-17.77c0-7.83-2-11.62-6.37-16.15s-11.3-4.55-19.13-4.55H199Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M162.23,138.74,199,173.35q-34.62,43.58-91.78,43.57-31.52,0-55.77-13.91A98.92,98.92,0,0,1,13.6,164.85Q0,140.6,0,109.08T13.6,53A101.09,101.09,0,0,1,51.29,14.21Q75.4,0,107.22,0a135.63,135.63,0,0,1,49.6,9q23,9,38.78,31.21L159.44,76.63a69.48,69.48,0,0,0-20.7-18.85,53.17,53.17,0,0,0-27.5-7.1q-17.31,0-29.51,7.57A50.19,50.19,0,0,0,63,78.64a63,63,0,0,0-6.49,28.89A64.41,64.41,0,0,0,63.19,137a49.44,49.44,0,0,0,19,20.55Q94.55,165,110.93,165q18.22,0,29.36-6.49T162.23,138.74Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCratrLogo);
export default __webpack_public_path__ + "static/media/cratr-logo.8e67839678bcebc4bfa23e3d501bed25.svg";
export { ForwardRef as ReactComponent };